import axios from 'axios';

export const sendForm = async ({ formData, roomData, code }) => {
  const form = {
    senderEmail: formData.senderEmail,
    senderFirstname: formData.senderFirstname,
    senderLastname: formData.senderLastname,
    senderOptin: formData.senderOptin,
    code: Object.values(code).join(''),
    schiftingsVraag: formData.schiftingsVraag,
  };

  await axios.post(roomData.registerUrl, form);

  return form;
};

export const getData = async () => {
  const result = await axios.get(`${process.env.VUE_APP_API_URL}/api/rooms`);

  return result.data;
};
